import axios from '@axios';
import HelperService from '@/services/HelperService';

const helperService = new HelperService();
const base = '/api/v1/visits';

export default {
  getVisits(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/in-cell/my-visits${queryString}`);
  },
  getCall(id) {
    return axios.get(`${base}/single-visit/${id}`);
  },
  sendReminderToVisitor(visitId, data) {
    return axios.post(`${base}/remind/visitor/${visitId}`, data);
  },
  requestCall(dto) {
    return axios.post(`${base}/request-visit/prisoner`, dto);
  },
  // updateWaitingRoomStatus(callId, status) {
  //   return axios.post(`${base}/call-state/set-visitor-in-waiting-room/${callId}`, status);
  // },
};
